/*
export function createScoreBoard(scene) {

    //////////////////////////////////////////////////////////////////////////////
    // this is for the scrore board

    var rectTitleHeight = 60;
    var rectTitleWidth = 240;

    const { width, height } = scene.scale;

    // VISUAL (rounded) --> use graphics for something more specific
    
    //const graphics = scene.add.graphics();

    //graphics.fillStyle(0xff0000, 1);

    //graphics.fillRoundedRect(
    //    width / 2 - rectTitleWidth / 2,
    //    rectTitleHeight / 4,
    //    rectTitleWidth,
    //    rectTitleHeight,
    //    12
    //);
    

    // ------------------------
    // Use your neon box image instead of graphics
    // ------------------------

    const boxX = width / 2 - rectTitleWidth / 2;
    const boxY = rectTitleHeight / 4;

    const neonBox = scene.add.image(
        boxX + rectTitleWidth / 2,
        boxY + rectTitleHeight / 2,
        'neonContainer'
    );

    neonBox.setDisplaySize(
        rectTitleWidth,
        rectTitleHeight
    );

    // Optional: make sure it’s behind the text
    neonBox.setDepth(0);

    //neonBox.setTintFill(0x0E011D);

    scene.add.text(
        width / 2 - rectTitleWidth / 2 + 15 + 15,
        rectTitleHeight / 2 + 2 + 5,
        'SCORE',
        {
            fontSize: '16px',
            fontStyle: 'bold',
            fill: '#E4A148'
        }
    );

    // the number - 65 is the padding and the text width
    scene.add.text(
        width / 2 + rectTitleWidth / 2 - 65 - 15,
        rectTitleHeight / 2 + 2 + 5,
        'LEVEL',
        {
            fontSize: '16px',
            fontStyle: 'bold',
            fill: '#E4A148'
        }
    );

    //scene.add.text(
    //    width / 2 - 10,
    //    rectTitleHeight / 2,
    //    '0',
    //    {
    //        fontSize: '20px',
    //        fontStyle: 'bold',
    //        fill: '#FFF'
    //    }
    //);

    scene.scoreText = scene.add.text(
        width / 2 - 10,
        rectTitleHeight / 2 + 1 + 5,
        scene.score,
        {
            fontSize: '20px',
            fontStyle: 'bold',
            color: '#F1CE4C'
        }
    );

    scene.scoreText.setOrigin(0.3, 0);

    // this is to show the number of actions taken. might need it later
    //scene.swapText = scene.add.text(
    //    20,
    //    20,
    //    `Moves: ${scene.swapCount}`,
    //    {
    //        fontSize: '20px',
    //        color: '#fff'
    //    }
    //);

    //////////////////////////////////////////////////////////////////////////////
}
*/

export function createScoreBoard(scene) {

    const width = scene.cameras.main.width;

    const badgeWidth = 100;
    const badgeHeight = 28;

    const x = width * 0.27;
    const y = 183;

    // Pink rounded background
    const background = scene.add.graphics();

    background.fillStyle(0xF48DBC, 1);

    background.fillRoundedRect(x - badgeWidth / 2, y - badgeHeight / 2, badgeWidth, badgeHeight, badgeHeight / 2);

    background.setDepth(50);

    // Score icon
    const icon = scene.add.image(x - 30, y, 'scoreDonut');

    icon.setOrigin(0.5).setDepth(51);

    icon.setDisplaySize(42, 42);

    // Score text
    const text = scene.add.text(
        x + 20,
        y,
        String(scene.score),
        {
            fontFamily: 'paytoneone',
            fontSize: '20px',
            //fontStyle: 'bold',
            color: '#FFFFFF'
        }
    );

    text.setOrigin(0.5).setDepth(51);

    scene.scoreText = text;
    scene.scoreBoardBackground = background;
    scene.scoreBoardIcon = icon;

    return {background, icon, text};
}


export function updateScoreBoard(scene) {

    if (!scene.scoreText) {
        return;
    }

    scene.scoreText.setText(String(scene.score));
}